var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LoadingIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h90v90H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "LoadingIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-3.543h90v-90H0z",
    transform: "translate(0 93.543)",
    fill: "#cbcbcb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LoadingIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LoadingIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 45A45 45 0 0045 0 45 45 0 000 45a45 45 0 0045 45 45 45 0 0045-45m-10.818 0A34.182 34.182 0 0145 79.182 34.181 34.181 0 0110.818 45 34.182 34.182 0 0145 10.817 34.182 34.182 0 0179.182 45",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.664 90A44.715 44.715 0 010 45.335a5.436 5.436 0 015.436-5.436 5.436 5.436 0 015.437 5.436 33.83 33.83 0 0033.791 33.793 5.436 5.436 0 015.436 5.436A5.436 5.436 0 0144.664 90",
    fill: "#00afff"
  })))));
}
export var url = __webpack_public_path__ + "3c253df62041f2e30f2ae78d580a068f.svg";
;
export default SvgLoadingIcon;